import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton"];

  connect() {
    this.timeout = null;
    this.submitButtonTarget.hidden = true;
  }

  submit() {
    // We want to clear the stored selected ids when we change filters
    localStorage.removeItem("selectAll");
    localStorage.removeItem("selectedIds");

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, 300);
  }
}
